import Input from 'antd/es/input';
import styled from 'styled-components';

import { SearchBarInputStyles } from '@shared/searchBar/styled';

export const StyledInput = styled(Input)`
  &&& {
    height: 56px;
    padding: 16px 12px;
    ${SearchBarInputStyles};

    .setur-input-prefix {
      margin-inline-end: 12px;
    }

    .setur-input-suffix {
      margin-inline-start: 12px;
    }
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  min-width: 275px;
  position: relative;
`;
